export const ACCOUNT_DETAIL_RESET_TO_DEAFULT = "ACCOUNT_DETAIL_RESET_TO_DEAFULT";
export const ACCOUNT_DETAIL_CHECKED_VALUES = "ACCOUNT_DETAIL_CHECKED_VALUES";